import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class RequestPageRelatedCiService {
	private readonly http = inject(HttpClient);
	private readonly authLoginService = inject(AuthLoginService);

	private postInsertCiRequest = environment.baseApiUrl + 'request/{idRequest}/relatedCIs';
	private deleteCiRequest = environment.baseApiUrl + 'request/{idRequest}/relatedCIs/{idCi}';
	private incidentDiscoveryUrl = environment.baseApiUrl + 'request/incident/discovery';

	constructor() {}

	addCiToRequest(idRequest: string, idCi: string): Observable<JSON> {
		const postInsertCiRequest = this.postInsertCiRequest.replace('{idRequest}', idRequest);
		const body = { requestID: idRequest, ciID: idCi };
		return this.http.post<JSON>(postInsertCiRequest, body, { headers: this.authLoginService.getHttpHeaders() });
	}

	removeCiFromRequest(idRequest: string, idCi: string): Observable<JSON> {
		const deleteCiRequest = this.deleteCiRequest.replace('{idRequest}', idRequest).replace('{idCi}', idCi);
		return this.http.delete<JSON>(deleteCiRequest, { headers: this.authLoginService.getHttpHeaders() });
	}

	getIncidentDiscovery(id_scope: string, id_category: string, id_topic: string, id_group: string, id_cmdb: string[]): Observable<any> {
		return this.http.get(this.incidentDiscoveryUrl, {
			headers: this.authLoginService.getHttpHeaders(),
			params: {
				id_scope: id_scope,
				id_category: id_category,
				id_topic: id_topic,
				id_group: id_group,
				id_cmdb: id_cmdb.join(','),
			},
		});
	}
}
